import React from 'react';
import styled from 'styled-components';

const LogoImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

interface LogoProps {
  size?: number;
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ size = 32, className }) => {
  return (
    <LogoImg 
      src="/logo-main.png"
      alt="OpenTender AI"
      width={size}
      height={size}
      className={className}
    />
  );
};

export default Logo;